const CHUNK_RELOAD_KEY = "afterpay_v2_chunk_reload";

const getSessionStorage = (): Storage | null => {
    try {
        return typeof window === "undefined" ? null : window.sessionStorage;
    } catch {
        return null;
    }
};

// Next reloads the document when a page chunk fails to load; lazy chunks need the same recovery
// so a stale deploy cannot leave a blank page. Reloading once per URL, and only when that guard
// can be stored, prevents reload loops. A visitor who has navigated away keeps the current page.
export const reloadOnceOnChunkError = <T>(load: () => Promise<T>): Promise<T> => {
    const initiatingHref = typeof window === "undefined" ? null : window.location.href;

    return load().then(
        (loaded) => {
            getSessionStorage()?.removeItem(CHUNK_RELOAD_KEY);

            return loaded;
        },
        (error: unknown) => {
            const storage = getSessionStorage();

            if (
                storage &&
                window.location.href === initiatingHref &&
                storage.getItem(CHUNK_RELOAD_KEY) !== initiatingHref
            ) {
                storage.setItem(CHUNK_RELOAD_KEY, initiatingHref);
                window.location.reload();
            }

            throw error;
        }
    );
};
